import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import * as clientActions from 'redux/modules/clients';

import * as productActions from 'redux/modules/products';
import * as ficheActions from 'redux/modules/fiches';
import * as ticketActions from 'redux/modules/tickets';
import * as supervisionActions from 'redux/modules/supervision';
import * as commercialActions from 'redux/modules/commercial';
import * as groupActions from 'redux/modules/groups';
import * as userActions from 'redux/modules/users';

import { isLoaded as areClientsLoaded, load as loadClients } from 'redux/modules/clients';
import { isLoaded as areModulesLoaded, load as loadModules } from 'redux/modules/modules';
import { initializeWithKey } from 'redux-form';
import { ClientForm } from 'components';
import { asyncConnect } from 'redux-connect';
var _ = require('underscore');

import {  Col, OverlayTrigger, Button, Tooltip } from 'react-bootstrap';
import { ConsultMenu } from 'components';


import { ReloadButton } from 'components';
import { translate } from 'react-i18next';

@translate(['common'])
@asyncConnect([{
  promise: ({ store: { dispatch, getState }, params }) => {
    const promises = [];
    if (!areClientsLoaded(getState())) {
      promises.push(dispatch(loadClients(params)));
    }
    if (!areModulesLoaded(getState())) {
      promises.push(dispatch(loadModules()));
    }

    promises.push(dispatch(commercialActions.load()));

    return Promise.all(promises);
  }
}])
@connect(
  state => ({
    clients: state.clients.data,
    editing: state.clients.editing,
    error: state.clients.error,
    loading: state.clients.loading,
    sendCredentialsLoading: state.clients.sendCredentialsLoading,
    modules: state.modules.data,
    sending: state.clients.sending,
    coms: state.commercial.data,
    editMode: state.clients.editMode,
    genBilanLoading:state.products.genBilanLoading,
    
  }),
  { ...clientActions, initializeWithKey })

export default class Clients extends Component {

  state = {
    searchQuery: (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('clients_search')) || '',
    currentPage: (typeof sessionStorage !== 'undefined' && parseInt(sessionStorage.getItem('clients_page'), 10)) || 1,
    perPage: 10
  };

  handleSearchChange = (e) => {
    const value = e.target.value;
    sessionStorage.setItem('clients_search', value);
    sessionStorage.setItem('clients_page', '1');
    this.setState({ searchQuery: value, currentPage: 1 });
  };

  handlePageChange = (page) => {
    sessionStorage.setItem('clients_page', String(page));
    this.setState({ currentPage: page });
  };

  componentDidMount() {

    this.props.dispatch(productActions.clearProducts());
    this.props.dispatch(ficheActions.clearFiches());
    this.props.dispatch(groupActions.clearGroups());
    this.props.dispatch(userActions.clear());
    this.props.dispatch(ticketActions.clearTickets());
    this.props.dispatch(supervisionActions.unmount());
  }

  render() {

    const {
      clients, error, editing, loading,
      load, modules, sendCredentialsLoading, resetCredentials,
      sending, coms, editMode,t
    } = this.props;

    let refreshClassName = 'fa fa-refresh';
    let refreshSCC = 'fa fa-refresh';

    if (loading) {
      refreshClassName += ' fa-spin';
    }

    const styles = require('./Clients.scss');

    var clients_rows = [];
    const searchQuery = this.state.searchQuery.toLowerCase();

    for (var id in clients) {
      var client = clients[id];
      
      // Filtrer par recherche
      if (searchQuery && 
          !client.login?.toLowerCase().includes(searchQuery) &&
          !client.sup_login?.toLowerCase().includes(searchQuery) &&
          !client.email?.toLowerCase().includes(searchQuery)) {
        continue;
      }
      const handleEdit = (client) => {
        const { editStart } = this.props; // eslint-disable-line no-shadow
        return () => editStart(String(client.id));
      };

      const handleGenBilans = (client) => {
       
        return () => {
          this.props.dispatch(productActions.generationsBilans(client)).then(csv=>{

            if (csv) {
              var filename = client.login+"_export_bilans_" + Date.now() + '.csv';
      
              var blob = new Blob([csv], { type: 'text/csv' });
              if (window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveBlob(blob, filename);
              }
              else {
                var elem = window.document.createElement('a');
                elem.href = window.URL.createObjectURL(blob);
                elem.download = filename;
                document.body.appendChild(elem);
                elem.click();
                document.body.removeChild(elem);
              }
            }
          })
        
        };
      };

      const handleDelete = (username) => {
        const { deleteClient } = this.props; // eslint-disable-line no-shadow
        return () => deleteClient(String(username));
      };

      const handleSendCredentials = (client) => {

        const { sendCredentials } = this.props; // eslint-disable-line no-shadow
        return () => {
          if (!confirm(t("main.create_client"))) {
            return
          }

          sendCredentials(client).then(() => {
            setTimeout(() => { resetCredentials(client.id); }, 2000);
          });
        }
      };

      var mods_names = client.modules.map((m) => {
        return m.name;
      }).join(', ');

      var com_names = client.abonnements.map((c) => {
        return c.name;
      }).join(', ');

      var mods_ids = client.modules.map((m) => {
        return m.id;
      });

      var com_ids = client.abonnements.map((m) => {
        return m.id;
      })

      var form = (
        <ClientForm formKey={String(client.id)} key={String(client.id)}
          commercials={coms}
          initialValues={{ id: client.id, ...client, modules: mods_ids }}
          initialValues2={{ id: client.id, ...client, modules: mods_ids }}
        />
      );


      var textSend = '';
      try {
        if (sending[client.id].loading == true) {
          refreshSCC += ' fa-spin';
          var disabled = true;
        } else {
          refreshSCC = 'fa fa-refresh';
          var disabled = false;
        }

        if (sending[client.id].loaded == true) {

          refreshSCC += ' fa-thumbs-up';
          var sendStyleBtn = 'btn-success';
          var textSend = '';
        }

      } catch (e) {
        refreshSCC = 'fa fa-refresh';
        var disabled = false;
        var sendStyleBtn = '';

        var textSend = '';
      }


      var tr = (
        <tr key={client.id}>
          <td>{client.sup_login}</td>
          <td>{client.login}</td>
          <td>{client.email}</td>
          <td>{mods_names}</td>
          <td>{com_names}</td>
          <td>
            <div style={{ width: '300px' }}>
              <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">
                <strong>{t("client.edit_client")}</strong>
              </Tooltip>}>
                <Button bsStyle='primary' onClick={handleEdit(client)}>
                  <i className="fa fa-pencil" />
                </Button>
              </OverlayTrigger>

              &nbsp;

              <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">
                <strong>{t("client.send_back_credentials")}</strong>
              </Tooltip>}>
                <button disabled={disabled} className={"btn btn-default " + sendStyleBtn}
                  onClick={handleSendCredentials(client)}>

                  <i className={refreshSCC} /> {textSend}
                </button>
              </OverlayTrigger>
              &nbsp;
              <div style={{ display: 'inline' }}>
                <ConsultMenu client={client.login} label={""} />
              </div>
              &nbsp;

              <div style={{ display: 'inline' }}>

                <button className={"btn btn-info "} disabled={this.props.genBilanLoading}
                  onClick={handleGenBilans(client)}>
                  {t("client.bilan_produits_csv")}
                </button>
                
              </div>

            </div>

          </td>
        </tr>);

      if (editing[id] == true) {
        clients_rows.push(form);
      } else {
        clients_rows.push(tr);
      }
    }

    // Pagination
    const { currentPage, perPage } = this.state;
    const totalPages = Math.ceil(clients_rows.length / perPage);
    const startIndex = (currentPage - 1) * perPage;
    const paginatedRows = clients_rows.slice(startIndex, startIndex + perPage);

    return (
      <div className={styles.clients + ' container'}>
        <h1>
          Clients <span>&nbsp;<ReloadButton module="clients" submit={load} loading={loading} /></span>
        </h1>
        <Helmet title="Clients" />
        
        <div style={{ marginBottom: '15px', display: 'flex', gap: '10px', alignItems: 'center' }}>
          <input
            type="text"
            className="form-control"
            placeholder={t("pagination.search") + "..."}
            value={this.state.searchQuery}
            onChange={this.handleSearchChange}
            style={{ maxWidth: '300px' }}
          />
          {this.state.searchQuery && (
            <Button bsStyle="default" onClick={() => {
              sessionStorage.removeItem('clients_search');
              sessionStorage.setItem('clients_page', '1');
              this.setState({ searchQuery: '', currentPage: 1 });
            }}>
              <i className="fa fa-times" />
            </Button>
          )}
        </div>

        {error &&

          <Col md={3} >
            <div className="alert alert-danger" role="alert">
              <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
              {t("main.connection_error")}
            </div></Col>}
        {clients && _.size(clients) > 0 &&

          <div className={"table-responsive " + styles.tableWrapper}>
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>{t("main.sup")}</th>
                  <th>{t("main.username")}</th>
                  <th>{t("main.email")}</th>
                  <th>{t("main.modules")}</th>
                  <th>{t("main.abonnements")}</th>
                  <th>{t("main.actions")}</th>
                </tr>
              </thead>
              <tbody>
                {paginatedRows}
              </tbody>
            </table>
            
            {totalPages > 1 && (
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px', marginTop: '15px' }}>
                <Button 
                  disabled={currentPage === 1} 
                  onClick={() => this.handlePageChange(currentPage - 1)}
                >
                  {t("pagination.previous")}
                </Button>
                <span>{currentPage} / {totalPages}</span>
                <Button 
                  disabled={currentPage === totalPages} 
                  onClick={() => this.handlePageChange(currentPage + 1)}
                >
                  {t("pagination.next")}
                </Button>
              </div>
            )}
          </div>
        }
      </div>
    );
  }
}

